import { Component, EventEmitter,  Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AsyncFeedbackService } from '@shared/services/async-feedback.service';
import { FunctionUtil } from '@shared/utils/function.util';
import { TransportationPaymentsStatus } from "@features/transportation-payments/enums/transportation-payments-status.enum";
import { AuthService } from '@core/services/auth.service';
import { TransportationPaymentsApiService } from '@features/transportation-payments/services/transportation-payments-api.service';
import { Shipment } from '@shared-features/models/shipment';

@Component({
  selector: 'app-payment-confirmation-modal',
  templateUrl: './payment-confirmation-modal.component.html',
  styleUrls: ['./payment-confirmation-modal.component.scss'],
})
export class PaymentConfirmationModalComponent extends BaseComponent implements OnInit {
  @Output() reloadComponent = new EventEmitter();
  @Input() selectedShipments: Shipment[] = [];
  @Input() startFrom: any;
  @Input() endAt: any;

  createdBy: string;
  totalAmount: number = 0;
  form: UntypedFormGroup;
  @Output() closeModal = new EventEmitter();

  constructor(
    private authService: AuthService,
    public formBuilder: UntypedFormBuilder,
    
    public asyncFeedbackService: AsyncFeedbackService,
    private transportationPaymentApiService: TransportationPaymentsApiService
  ) {
    super();
  }

  ngOnInit(): void {
    this.createdBy = this.authService.currentUser$.value.name;
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedShipments'] && changes['selectedShipments'].currentValue) {
      this.selectedShipments.forEach((shipment) => {
        this.totalAmount = shipment.totalFleetCost + this.totalAmount;
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  initForm() {
    this.form = new UntypedFormGroup({
      paymentDate: new UntypedFormControl(new Date()),
      bankRef: new UntypedFormControl(null, Validators.maxLength(50)),
    });
  }

  save() {
    this.load(
      this.transportationPaymentApiService.createTransportationPayment({
        shipmentIds: this.selectedShipments.map((shipment) => shipment.id),
        paymentStatus: TransportationPaymentsStatus.PENDING,
        paymentDate: FunctionUtil.convertDate(this.form.get('paymentDate').value),
        bankReference: this.form.get('bankRef').value,
        startDate: FunctionUtil.convertDate(this.startFrom),
        endDate: FunctionUtil.convertDate(this.endAt),
      }),
      {
        successMessagePath: 'SuccessMessages.PaymentCreatedSuccessfully',
      }
    ).subscribe((res) => {
      this.closeModal.emit();
      this.reloadComponent.emit();
    });
  }
}
